import React from 'react';

/**
 * WordMark — heart icon + "matchitup" brand wordmark
 * "it" renders in Ember (#E8430A), rest in dark or white (inverted)
 * Font: Bricolage Grotesque
 */
const WordMark = ({ size = 'md', inverted = false, className = '' }) => {
  const textSizes = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-3xl',
  };

  const baseColor = inverted ? '#ffffff' : '#18181B';

  return (
    <div className={`flex items-center ${className}`}>
      <span
        className={`${textSizes[size]} font-extrabold tracking-tight leading-none wordmark-font`}
        style={{ fontFamily: "'Bricolage Grotesque', sans-serif", color: baseColor, fontWeight: 900 }}
      >
        match<span style={{ color: '#E8430A' }}>it</span>up<sup style={{ fontSize: '0.55em', verticalAlign: 'super', lineHeight: 0, opacity: 0.7 }}>©</sup>
      </span>
    </div>
  );
};

export default WordMark;
